export default __webpack_public_path__ + "static/media/sailboat-icon-128.9d067322.ico";